<template>
  <Modal
    title=""
    data-testid="rename-portfolio-modal"
    :is-open="isOpen"
    size="md"
    @close="emit('close')"
  >
    <Heading :level="3" class="renamePortfolio__title"
      >Alterar nome da Carteira</Heading
    >
    <div class="renamePortfolio__input">
      <InputText
        v-model="portfolioRenamed"
        :max-length="30"
        label="Nome da carteira"
      />
      <BaseText class="renamePortfolio__counter" size="p6">
        {{ counter }}
      </BaseText>
    </div>
    <template #buttonContainer>
      <ButtonContainer>
        <template #button-primary>
          <ButtonPrimary
            data-testid="save-button"
            label="Salvar"
            @click="savePortfolioName"
          />
        </template>
      </ButtonContainer>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, computed } from 'vue';
import {
  Modal,
  InputText,
  BaseText,
  ButtonContainer,
  ButtonPrimary,
  Heading
} from '@warrenbrasil/nebraska-web';
import { rename } from '@/modules/wealth/services/portfolio';

const props = defineProps({
  isOpen: { type: Boolean, default: false },
  portfolioId: { type: String, required: true },
  portfolioName: { type: String, required: true }
});

const emit = defineEmits(['close', 'reload']);

async function savePortfolioName() {
  try {
    await rename(props.portfolioId, portfolioRenamed.value);
    emit('close');
    emit('reload');
  } catch (error) {
    console.error(error);
  }
}

const portfolioRenamed = ref('');

const counter = computed(() => {
  return `${portfolioRenamed.value.length}/30`;
});

onMounted(() => {
  portfolioRenamed.value = props.portfolioName;
});

watch(
  () => props.portfolioName,
  () => {
    portfolioRenamed.value = props.portfolioName;
  }
);
</script>

<style lang="less" scoped>
:deep(.modal-content) {
  padding: 0 @size-spacing-x600;
}

.renamePortfolio__title {
  color: @element-primary;
  margin-bottom: @size-spacing-x600;
  text-align: start;
  width: 100%;
}

.renamePortfolio__input {
  width: 100%;
  margin-bottom: @size-spacing-x700;
}

.renamePortfolio__counter {
  margin: @size-spacing-x300 0;
  text-align: right;
}
</style>
